import { Component } from '@angular/core';
import { OnInit, Input, ViewChild } from '@angular/core';

import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions, SortChangedEvent, PaginationChangedEvent, Column } from 'ag-grid-community';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../services/alerts.service';
import { WorkflowQueryService } from '../../services/workflow-query.service';
import { UserService } from '../../../services/user.service';

/**
 * Component for viewing workflow queries assigned to a batch.
 */
@Component({
	selector: 'workflow-batch-queries',
	templateUrl: './batch-queries-ag.component.html',
	styleUrl: './batch-queries-ag.component.css'
})
export class BatchQueriesAgComponent implements OnInit {
	@Input() batch: any;

	LOCALIZATION: any;

	pagination = {
		elementsPerPage: 20,
		elementsPerPageSizes: [20, 50, 100],
		totalElements: 0
	};

	// Properties applied to all columns
	defaultColDef = {
		flex: 1
	};

	columns: any[] = [
		{ field: 'id', hide: true },
		{ field: 'name', headerName: 'Name', sortable: false, filter: false, tooltipField: 'name' },
		{ field: 'queryListNamesStr', headerName: 'Query Lists', sortable: false, filter: false, tooltipField: 'queryListNamesStr' },
		{ field: 'queryTerms', headerName: 'Search Terms', sortable: false, filter: false, tooltipField: 'queryTerms' },
		{ field: 'queryType', headerName: 'Type', sortable: false, filter: false, tooltipField: 'queryType' },
		{
			field: 'category', headerName: 'Category', sortable: false, filter: false,
			valueGetter: (params: any) => params.data?.category?.name || 'None',
			tooltipValueGetter: (params: any) => params.data?.category?.name || 'None'
		}
	];

	gridData: any[] = [];
	ner: any[] = [];

	constructor(
		private alertsService: AlertsService,
		private workflowQueryService: WorkflowQueryService,
		private userService: UserService,
		private modalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadData();
		this.loadNERData();
	}

	private loadData(): void {
		this.workflowQueryService.getBatchQueries(this.batch.batchId).then(
			(data: any) => {
				this.gridData = data || [];

				// Returned data is a simple array
				// All data is returned at once
				this.pagination.totalElements = this.gridData.length;
			},
			(err) => {
				console.error("Failed to load batch queries", err);

				this.gridData = [];

				this.alertsService.error({
					message: this.LOCALIZATION.noQueries
				});
			}
		);
	}

	private loadNERData(): void {
		let nerids: any[] = [];
		this.batch.parameters?.forEach((p: any) => {
			if ("QUERY" == p.type) {
				var ids = p.values.ner_ids || "";
				nerids = ids.split(",");
			}
		});

		nerids.forEach((n: any) => {
			if (n) {
				this.ner.push({ id: n });
			}
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
